import { useState } from 'react';
import { applyTheme, getTheme } from '../lib/theme.js';

/** Botão deslizante sol/lua (canto superior direito, fixo em qualquer tela). */
export function ThemeToggle() {
  const [theme, setTheme] = useState(getTheme());
  const light = theme === 'light';

  function toggle() {
    const novo = light ? 'dark' : 'light';
    setTheme(novo);
    applyTheme(novo);
  }

  return (
    <button
      type="button"
      className={`theme-toggle ${light ? 'light' : 'dark'}`}
      onClick={toggle}
      aria-label={light ? 'Mudar para tema escuro' : 'Mudar para tema claro'}
      title={light ? 'Tema claro' : 'Tema escuro'}
    >
      <span className="tt-track">
        <span className="tt-icon tt-sun" aria-hidden="true">☀️</span>
        <span className="tt-icon tt-moon" aria-hidden="true">🌙</span>
        <span className="tt-knob" />
      </span>
    </button>
  );
}
